// IntegratedPromotional.jsx — 통합 홍보물 메뉴(promotional) 화면 (2026-10-19, 5단계 홍보물 5-6)
//   편집 창에서 고른 회사들의 홍보물 주문을 한 화면에서 본다. 홍보물 관리 화면(PromotionalManagement) 한 벌을 그대로 쓰고
//   주소만 메뉴 주소(/api/admin/integrated-menus/{id}/promotional, 서버 integrated-promotional.route.js)로 바꾼다.
//   새 주문은 회사를 꼭 고른다(고를 회사 = 메뉴 회사 중 홍보물을 쓰는 회사 — 서버가 목록과 함께 준다).
//   회사값 없는 주문은 '회사 확인 필요'로 보이고 운영자·홍보물 관리 담당자가 [회사 정하기](사용자 결정 2).
//   금액 관리(품목·원가)는 본사에서만. key={menuId}: 같은 주소에서 메뉴를 바꿔 열면 새로 그린다.
import React, { useMemo } from 'react';
import PromotionalManagement from './PromotionalManagement';
import { scopedPromoApi } from './promotionalmanagement/promoApi';

export default function IntegratedPromotional({ menuId }) {
  const api = useMemo(() => scopedPromoApi(`/api/admin/integrated-menus/${menuId}/promotional`, { integrated: true }), [menuId]);
  return <PromotionalManagement key={menuId} api={api} />;
}
